import { render } from "./container-details-device.vue?vue&type=template&id=ba1d4d4c&scoped=true"
import script from "./container-details-device.vue?vue&type=script&lang=js"
export * from "./container-details-device.vue?vue&type=script&lang=js"

import "./container-details-device.vue?vue&type=style&index=0&id=ba1d4d4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1d4d4c"]])

export default __exports__